import { render, staticRenderFns } from "./Report2.vue?vue&type=template&id=4fab1583&scoped=true"
import script from "./Report2.vue?vue&type=script&lang=js"
export * from "./Report2.vue?vue&type=script&lang=js"
import style0 from "./Report2.vue?vue&type=style&index=0&id=4fab1583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fab1583",
  null
  
)

export default component.exports